"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const amount_1 = require("./amount");
function convertAssetPriceToPlanck(assetPrice, decimals) {
    return amount_1.Amount.fromSigna(assetPrice).multiply(Math.pow(10, (decimals - 8))).getPlanck();
}
exports.convertAssetPriceToPlanck = convertAssetPriceToPlanck;
//# sourceMappingURL=convertAssetPriceToPlanck.js.map